<template>
  <div>
    <div class="row">
      <!-- INTER COMPANY REF INFORMATION -->
      <div class="col-12" v-if="worker.external_finance_ref !== null || worker.rel_company_info.company_external_finance_ref !== null">
        <b-card :header="inter_company_name + ' Profile Information'" header-tag="h4" body-class="mb-3 record_card_body">
          <div class="row">
            <!-- Worker Reference -->
            <div class="col-lg-6 form-group">
              <label class="form-label" for="ic_worker_ref">Worker Reference</label>
              <p id="ic_worker_ref">
                <span v-if="true">{{ worker.external_finance_ref }}</span>
                <span v-else>&nbsp;</span>
              </p>
            </div>
            <!-- Company Reference -->
            <div class="col-lg-6 form-group" v-if="worker.rel_company_info.employment_type_id !== null && worker.rel_company_info.employment_type_id === 32">
              <label class="form-label" for="ic_company_ref">Limited Company Reference</label>
              <p id="ic_company_ref">
                <span v-if="true">{{ worker.rel_company_info.company_external_finance_ref }}</span>
                <span v-else>&nbsp;</span>
              </p>
            </div>
          </div>
        </b-card>
      </div>
      <div class="col-lg-5" v-if="!toggle_show_finance_ref && (worker.external_finance_ref === null || worker.rel_company_info.company_external_finance_ref)">
        <button class="btn orcaBtn warning w-100 sm_btn mb-3" @click.prevent="show_add_external_ref">Add External Reference</button>
      </div>

      <div class="col-12" v-if="toggle_show_finance_ref">
        <b-card header="Add External Finance Ref" header-tag="h4" body-class="mb-3 record_card_body">
          <ValidationObserver ref="addExternalRef" slim>
            <form role="form" @submit.prevent="add_external_ref" class="row" autocomplete="off">

              <ValidationProvider rules="required|numeric" v-slot="{errors, classes}" name="Worker External Ref" tag="div" class="col-lg-6 form-group">
                <label class="form-label" for="worker_external_finance_ref">Worker Ref</label>
                <input type="search" v-model="worker_external_finance_ref" id="worker_external_finance_ref" name="worker_external_finance_ref"
                       class="form-input requiredField" :class="classes" maxlength="255">
                <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
              </ValidationProvider>
              <ValidationProvider rules="required|numeric" v-slot="{errors, classes}" name="Limited Company External Ref" tag="div" class="col-lg-6 form-group"
                                  v-if="worker.rel_company_info.employment_type_id !== null && worker.rel_company_info.employment_type_id === 32">
                <label class="form-label" for="company_external_finance_ref">Limited Company Ref</label>
                <input type="search" v-model="company_external_finance_ref" id="company_external_finance_ref" name="company_external_finance_ref"
                       class="form-input requiredField" :class="classes" maxlength="255">
                <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
              </ValidationProvider>
              <div class="col-6" v-else></div>

              <div class="col-6">
                <button class="btn orcaBtn grey_bg w-100 sm_btn" @click.prevent="hide_add_finance_ref">Cancel</button>
              </div>
              <div class="col-6">
                <button type="submit" class="btn orcaBtn w-100 sm_btn" :disabled="saving_external_ref">
                  <span v-if="saving_external_ref" class="btnLoading"><i class="fas fa-spinner fa-pulse"></i>Saving ...</span>
                  <span v-else>Save</span>
                </button>
              </div>
            </form>
          </ValidationObserver>
        </b-card>
      </div>

      <div class="col-12">
        <b-card header="Live Assignments" header-tag="h4" body-class="mb-3 record_card_body">
          <div class="row">
            <div class="col-6">
              <button @click="new_assignment" class="btn orcaBtn sm_btn"><i class="fas fa-plus"></i> New Assignment</button>
            </div>
            <div class="col-6 text-right">
              <button @click="end_all_assignments" class="btn orcaBtn danger sm_btn"><i class="fas fa-plus"></i> End All Assignments</button>
            </div>
          </div>
          <div class="row" v-if="!notEmptyObject(live_ass)">
            <div class="col-12">
              <h5 class="red_color text-uppercase text-center mb-0 mt-3">This worker is currently not assigned to a CCO.</h5>
            </div>
          </div>
          <div class="row mt-3" v-else>
            <div class="col-12">
              <div class="row" v-if="!check_add_to_gang">
                <div class="col-xl-6 placement_container" v-for="la in live_ass">
                  <div class="placement">
                    <div class="placement_details">
                      <div class="row">
                        <div class="col-12">
                          <h3 style="font-size: 0.9rem;" class="orange_color font-weight-bold text-uppercase mb-0" v-if="la.is_gang_leader"><i class="fas fa-crown"></i>&nbsp; Gang
                            Leader</h3>
                          <h3 style="font-size: 0.9rem;" class="b3_color font-weight-bold text-uppercase mb-0" v-if="la.gang_leader !== null"><i class="fas fa-people-arrows"></i>&nbsp;
                            <span class="gang_leader_go" @click.prevent="go_to_gang_leader_profile(la.gang_leader.id)">{{ la.gang_leader.person.first_name }} {{
                                la.gang_leader.person.surname
                              }}</span></h3>
                          <h3 class="bp_color mb-0" style="font-size: 1.2rem;">{{ la.order_job.order_ref }} - {{ la.order_job.rel_order_position.job_title }}</h3>
                          <h5 class="mb-0">{{ la.company.company_name }}</h5>
                          <p class="pt-0" style="font-size: 0.7rem;">[{{ la.order_job.rel_order_location.short_site_name }}] - {{
                              la.order_job.rel_order_location.job_address_full
                            }}</p>
                          <p style="font-size: 0.7rem;">
                            <strong class="d-inline-block" style="width: 80px">Duration:</strong> {{ la.start_date | formatDate }}
                            <span v-if="la.end_date !== null"> - {{ la.end_date | formatDate }}</span>
                          </p>
                          <p class="pt-0 mb-0" style="font-size: 0.7rem;">
                            <strong class="d-inline-block" style="width: 80px">Rate:</strong>
                            {{ la.position_rate.pay_amount | currency }} [{{ la.position_rate.pay_type }} - {{ la.position_rate.rate_type }}]
                          </p>
                          <p class="pt-0 mb-0" style="font-size: 0.7rem;" v-if="la.position_rate.admin_fee_type === '£ (Pound)'">
                            <strong class="d-inline-block" style="width: 80px">Admin Fee:</strong>
                            {{ la.position_rate.admin_fee_amount | currency }}
                          </p>
                          <p class="pt-0 mb-0" style="font-size: 0.7rem;" v-if="la.position_rate.admin_fee_type === '% (Percentage)'">
                            <strong class="d-inline-block" style="width: 80px">Admin Fee:</strong>
                            {{ la.position_rate.admin_fee_amount | percentage }}
                          </p>
                          <p class="font-italic" style="font-size: 0.7rem;">
                            Assigned by {{ la.assigned_by.first_name }} {{ la.assigned_by.surname }} on {{ la.created_at |formatDateTime }}
                          </p>
                        </div>
                      </div>
                    </div>
                    <div class="placement_buttons">
                      <button @click.prevent="view_order(la.order_job.id)" class="btn orcaBtn sm_btn greenBtn mb-2 mr-2" data-toggle="tooltip"
                              title="View Order"><i class="fas fa-eye"></i>&nbsp; O
                      </button>
                      <button @click.prevent="view_client(la.company.id)" class="btn orcaBtn sm_btn greenBtn mb-2" data-toggle="tooltip"
                              title="View Company"><i class="fas fa-eye"></i>&nbsp; C
                      </button>
                      <button v-if="!la.is_gang_leader" @click.prevent="make_gang_leader(la)" class="btn orcaBtn sm_btn warning mb-2" data-toggle="tooltip"
                              title="Make Gang Leader"><i class="fas fa-crown"></i></button>
                      <button v-if="la.is_gang_leader" @click.prevent="cancel_gang_leader(la)" class="btn orcaBtn sm_btn danger mb-2 ml-2" data-toggle="tooltip"
                              title="Remove Gang Leader Status"><i class="fas fa-times"></i> <i class="fas fa-crown"></i></button>
                      <br>
                      <button @click.prevent="add_to_gang(la)" class="btn orcaBtn sm_btn grey_bg mb-2" data-toggle="tooltip"
                              title="Add to gang"><i class="fas fa-people-arrows"></i></button>
                      <button v-if="la.gang_leader_id !== null" @click.prevent="remove_from_gang(la)" class="btn orcaBtn sm_btn danger mb-2 ml-2" data-toggle="tooltip"
                              title="Remove from gang"><i class="fas fa-times"></i> <i class="fas fa-people-arrows"></i></button>
                      <button @click.prevent="end_assignment(la)" class="btn orcaBtn sm_btn mb-2 danger w-100" data-toggle="tooltip"
                              title="End Assignment"><i class="fas fa-stop"></i>&nbsp; End
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row" v-else-if="check_add_to_gang && notEmptyObject(add_gang_info)">
                <div class="col-12">
                  <ValidationObserver ref="addToGangForm" slim>
                    <form role="form" @submit.prevent="submit_add_to_gang" class="row">

                      <div class="col-md-6 mb-3">
                        <h3 class="bp_color mb-0" style="font-size: 1.2rem;">
                          {{ add_gang_info.order_job.order_ref }} - {{ add_gang_info.order_job.rel_order_position.job_title }}
                        </h3>
                        <h5 class="mb-0">{{ add_gang_info.company.company_name }}</h5>
                        <p class="pt-0" style="font-size: 0.7rem;">
                          [{{ add_gang_info.order_job.rel_order_location.short_site_name }}] - {{ add_gang_info.order_job.rel_order_location.job_address_full }}
                        </p>

                        <div v-if="add_gang_info.is_gang_leader">
                          <h5 class="red_color mt-3 mb-1"><i class="fas fa-exclamation-triangle"></i> Worker is a Gang Leader</h5>
                          <p class="pt-0 red_color">If you assign this worker to a gang leader for this order assignment, you will remove all workers in their current gang.</p>
                        </div>
                        <div v-if="add_gang_info.gang_leader !== null">
                          <h5 class="red_color mt-3 mb-1"><i class="fas fa-exclamation-triangle"></i> Worker is already assigned to a Gang</h5>
                        </div>
                      </div>

                      <!-- Gang Leader -->
                      <div class="col-md-6">
                        <div class="form-group" v-if="add_gang_info.gang_leader !== null">
                          <label class="form-label" for="current_gang_leader">Current Gang Leader</label>
                          <p id="current_gang_leader"><span>{{ add_gang_info.gang_leader.person.first_name }} {{ add_gang_info.gang_leader.person.surname }}</span></p>
                        </div>
                        <ValidationProvider rules="required" v-slot="{errors, classes}" name="Gang Leader" tag="div" class="form-group"
                                            v-if="add_gang_info.gang_leaders.length > 0">
                          <label class="form-label" for="gang_leader">Assign to Gang Leader</label>
                          <multiselect v-model="add_gang_info.new_gang_leader" id="gang_leader" class="requiredField" :class="classes" name="gang_leader" placeholder=""
                                       :options="add_gang_info.gang_leaders" :custom-label="worker_label" :show-labels="false"></multiselect>
                          <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                        </ValidationProvider>
                        <div v-else>
                          <h5 class="red_color mt-3 mb-1"><i class="fas fa-exclamation-triangle"></i> No Gang Leaders for this job order</h5>
                        </div>
                      </div>

                      <div class="col-md-6 mb-2 mb-md-0">
                        <button @click.prevent="cancel_add_to_gang" class="btn orcaBtn grey_bg sm_btn w-100">Cancel Add to Gang</button>
                      </div>
                      <div class="col-md-6">
                        <button type="submit" class="btn orcaBtn sm_btn w-100" v-if="add_gang_info.gang_leaders.length > 0">
                          <span v-if="adding_to_gang" class="btnLoading"><i class="fas fa-spinner fa-pulse"></i>Assigning to Gang ...</span>
                          <span v-else>Assign to Gang</span>
                        </button>
                      </div>
                    </form>
                  </ValidationObserver>
                </div>
              </div>
            </div>
          </div>
        </b-card>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <b-card header="Historic Assignments" header-tag="h4" body-class="mb-3 record_card_body">
          <div class="row">
            <div class="col-12" style="height: 400px">
              <historicDatable :row-data="historic_ass" :loading-message="'Loading Historic Assignments...'" :no-rows-message="'No Historic Assignments Found'"
                               :columns="historic_ass_columns" :type="'assignment'" :record-type="'assignment'"></historicDatable>
            </div>
          </div>
        </b-card>
      </div>
    </div>

  </div>
</template>

<script>
import historicDatable from 'datatables/assignments_datatable'
import Multiselect from 'vue-multiselect';

export default {
  name: "assignments",
  props: ['worker', 'live_ass', 'historic_ass'],
  components: {historicDatable, Multiselect},
  data() {
    return {
      historic_ass_columns: [
        {headerName: 'Assigned Date', minWidth: 150, valueGetter: this.h_assigned_date_vg},
        {headerName: 'Client Name', minWidth: 200, field: 'company.company_name'},
        {headerName: 'Order Ref', minWidth: 110, field: 'order_job.order_ref'},
        {headerName: 'Job Title', minWidth: 150, field: 'order_job.rel_order_position.job_title'},
        {headerName: 'Pay Rate', minWidth: 100, valueGetter: this.h_pay_rate_vg},
        {headerName: 'Admin Rate', minWidth: 115, valueGetter: this.h_admin_rate_vg},
        {headerName: 'Start Date', minWidth: 115, valueGetter: this.h_start_date_vg},
        {headerName: 'End Date', minWidth: 115, valueGetter: this.h_end_date_vg},
        {headerName: 'Assigned By', minWidth: 150, valueGetter: this.assigned_by_vg},
        {headerName: 'Gang Leader', minWidth: 90, valueGetter: this.h_gang_leader_vg},
        {headerName: 'Part of Gang', minWidth: 95, valueGetter: this.h_part_of_gang_vg},
        {headerName: 'Gang Lead By', minWidth: 135, valueGetter: this.h_gang_lead_by_vg},
      ],
      check_add_to_gang: false,
      add_gang_info: {},
      adding_to_gang: false,

      toggle_show_finance_ref: false,
      worker_external_finance_ref: '',
      company_external_finance_ref: '',
      saving_external_ref: false
    }
  },
  computed: {
    inter_company_name() {
      if (this.crmType === 'payroll') {
        return 'V3'
      }
      if (this.crmType === 'recruitment') {
        return 'GM'
      }
    }
  },
  methods: {
    new_assignment() {
      this.$store.commit('CURRENT_NEW_ASSIGNMENT_WORKER_ID', {
        worker_id: this.worker.id,
        compliance_test_id: null
      });
      // Close current tab and open up worker assignment
      this.$nextTick(() => {
        this.$router.push('/workers/assignment');
        this.$tabs.refresh('/workers/assignment', true);
      });
    },
    end_all_assignments() {
      this.$snotify.confirm('', '', {
        closeOnClick: false,
        position: 'centerCenter',
        backdrop: 0.5,
        html: '<div class="snotifyToast__title">Confirm end all assignments</div>' +
            '<div class="snotifyToast__body">' +
            'Are you sure you want to end all assignments for this worker?' +
            '<div class="snotify-icon snotify-icon--confirm"><i class="fas fa-2x fa-crown"></i></div>' +
            '</div>',
        buttons: [
          {
            text: 'End All Assignments', action: (toast) => {
              axios.post(this.crmApiPath + 'assignments/worker/end_assignments/' + this.worker.id).then(() => {
                this.$bus.$emit('assignments::reload', {action: true});
                this.$snotify.remove(toast.id)
              })
            }
          },
          {
            text: 'Cancel', action: (toast) => {
              this.$snotify.remove(toast.id)
            }
          }
        ]
      });
    },

    // external finance ref
    show_add_external_ref() {
      this.toggle_show_finance_ref = true;
    },
    hide_add_finance_ref() {
      this.toggle_show_finance_ref = false;
      this.worker_external_finance_ref = '';
      this.company_external_finance_ref = '';
    },
    add_external_ref() {
      this.$refs.addExternalRef.validate().then(success => {
        if (!success) {
          this.formErrorsValidationScroll(this.$refs.addExternalRef);
        }
        else {
          this.saving_external_ref = true;
          axios.post(this.crmApiPath + 'worker/' + this.worker.id + '/add/external_refs', {
            worker_external_finance_ref: this.worker_external_finance_ref,
            employment_type_id: this.worker.rel_company_info.employment_type_id,
            company_external_finance_ref: this.company_external_finance_ref,
            log_by_type: 'App\\Models\\Users\\User',
            log_by_id: this.$store.state.auth.me.id
          }).then(() => this.$tabs.refresh('/workers/profile', true))
        }
      });

    },

    // Value Getters
    assigned_by_vg(params) {
      return params.data.assigned_by.first_name + ' ' + params.data.assigned_by.surname;
    },
    h_assigned_date_vg(params) {
      return this.$options.filters.formatDateTime(params.data.created_at);
    },
    h_pay_rate_vg(params) {
      return this.$options.filters.currency(params.data.position_rate.pay_amount);
    },
    h_admin_rate_vg(params) {
      if (params.data.position_rate.admin_fee_type === '£ (Pound)') {
        return this.$options.filters.currency(params.data.position_rate.admin_fee_amount);
      }
      else if (params.data.position_rate.admin_fee_type === '% (percentage)') {
        return this.$options.filters.percentage(params.data.position_rate.admin_fee_amount);
      }
    },
    h_start_date_vg(params) {
      return this.$options.filters.formatDate(params.data.start_date);
    },
    h_end_date_vg(params) {
      return this.$options.filters.formatDate(params.data.end_date);
    },
    h_gang_leader_vg(params) {
      return params.data.is_gang_leader ? 'Yes' : 'No';
    },
    h_part_of_gang_vg(params) {
      return params.data.gang_leader !== null ? 'Yes' : 'No';
    },
    h_gang_lead_by_vg(params) {
      return params.data.gang_leader !== null ? params.data.gang_leader.full_name : '';
    },

    // current assignment functions
    go_to_gang_leader_profile(id) {
      this.$store.commit('CURRENT_PROFILE_WORKER_ID', id);
      this.$store.commit('SET_WORKER_TAB_INDEX', 0);
      this.$nextTick(() => {
        this.$tabs.refresh('/workers/profile', true)
      });
    },

    make_gang_leader(assignment) {
      this.$snotify.confirm('', '', {
        closeOnClick: false,
        position: 'centerCenter',
        backdrop: 0.5,
        html: '<div class="snotifyToast__title">Make Gang Leader</div>' +
            '<div class="snotifyToast__body">' +
            'Are you sure you wish to make this worker a gang leader on this order assignment?<br><br>' +
            'If the worker is part of a gang they will be removed for this when changed to a gang leader.' +
            '<div class="snotify-icon snotify-icon--confirm"><i class="fas fa-2x fa-crown"></i></div>' +
            '</div>',
        buttons: [
          {
            text: 'Make Gang Leader', action: (toast) => {
              let update_ass = assignment;
              update_ass['is_gang_leader'] = true;
              update_ass['gang_leader_id'] = null;
              update_ass['log_by_type'] = 'App\\Models\\Users\\User';
              update_ass['log_by_id'] = this.$store.state.auth.me.id;

              axios.patch(this.crmApiPath + 'assignments/worker_assignments/' + assignment.id, update_ass).then(() => {
                this.$bus.$emit('assignments::reload', {action: true});
                this.$snotify.remove(toast.id)
              })
            }
          },
          {
            text: 'Cancel', action: (toast) => {
              this.$snotify.remove(toast.id)
            }
          }
        ]
      });
    },
    cancel_gang_leader(assignment) {
      this.$snotify.confirm('', '', {
        closeOnClick: false,
        position: 'centerCenter',
        backdrop: 0.5,
        html: '<div class="snotifyToast__title">Remove Gang Leader Status</div>' +
            '<div class="snotifyToast__body">' +
            'Are you sure you wish to remove this workers gang leader status on this order assignment?<br><br>' +
            'If the worker has a gang they will be removed for this change is made.' +
            '<div class="snotify-icon snotify-icon--confirm"><i class="fas fa-2x fa-crown"></i></div>' +
            '</div>',
        buttons: [
          {
            text: 'Make Gang Leader', action: (toast) => {
              let update_ass = assignment;
              update_ass['is_gang_leader'] = false;
              update_ass['gang_leader_id'] = null;
              update_ass['log_by_type'] = 'App\\Models\\Users\\User';
              update_ass['log_by_id'] = this.$store.state.auth.me.id;

              axios.post(this.crmApiPath + 'assignments/worker_assignments/remove_gang_leader_status/' + assignment.id, update_ass).then(() => {
                this.$bus.$emit('assignments::reload', {action: true});
                this.$snotify.remove(toast.id)
              })
            }
          },
          {
            text: 'Cancel', action: (toast) => {
              this.$snotify.remove(toast.id)
            }
          }
        ]
      });
    },
    add_to_gang(assignment) {
      // assignment info
      this.add_gang_info = assignment;
      // gang leaders for order relating to assignment
      this.add_gang_info['new_gang_leader'] = null
      axios.get(this.crmApiPath + 'assignments/order_job/list_gang_leaders/' + assignment.order_job_id).then(gang_leaders => {
        let temp = gang_leaders.data;
        this.add_gang_info['gang_leaders'] = temp.filter(t => t.worker_id !== assignment.worker_id)
        if (assignment.gang_leader_id !== null) {
          this.add_gang_info['gang_leaders'] = temp.filter(t => t.worker_id !== assignment.gang_leader_id)
        }
        this.$nextTick(() => this.check_add_to_gang = true)
      })
    },
    remove_from_gang(assignment) {
      let update_ass = assignment;
      update_ass['gang_leader_id'] = null;
      update_ass['log_by_type'] = 'App\\Models\\Users\\User';
      update_ass['log_by_id'] = this.$store.state.auth.me.id;

      axios.patch(this.crmApiPath + 'assignments/worker_assignments/' + assignment.id, update_ass).then(() => {
        this.$bus.$emit('assignments::reload', {action: true});

      })
    },
    worker_label({worker}) {
      return `${worker.person.first_name} ${worker.person.surname}`;
    },
    cancel_add_to_gang() {
      this.add_gang_info = {};
      this.check_add_to_gang = false;
    },

    submit_add_to_gang() {
      this.$refs.addToGangForm.validate().then(success => {
        if (!success) {
          this.formErrorsValidationScroll(this.$refs.addToGangForm);
        }
        else {
          let update_ass = this.add_gang_info;
          update_ass['is_gang_leader'] = false;
          update_ass['gang_leader_id'] = this.add_gang_info.new_gang_leader.worker_id;
          update_ass['log_by_type'] = 'App\\Models\\Users\\User';
          update_ass['log_by_id'] = this.$store.state.auth.me.id;
          axios.post(this.crmApiPath + 'assignments/worker_assignments/add_gang/' + update_ass.id, update_ass).then((res) => {
            this.$bus.$emit('assignments::reload', {action: true});
            this.add_gang_info = {};
            this.check_add_to_gang = false;
          })
        }
      });
    },

    view_order(order_id) {
      this.$store.commit('CURRENT_ORDER_ID', order_id);
      this.$store.commit('SET_ORDER_TAB_INDEX', 0);
      this.$nextTick(() => {
        this.$router.push('/order/view');
        this.$tabs.refresh('/order/view', true)
      });
    },
    view_client(client_id) {
      this.$store.commit('CURRENT_RECORD_COMPANY_ID', client_id);
      this.$store.commit('SET_COMPANY_TAB_INDEX', 0);
      this.$nextTick(() => {
        this.$router.push('/company/record');
        this.$tabs.refresh('/company/record', true)
      });
    },
    end_assignment(assignment) {
      this.$snotify.confirm('', '', {
        closeOnClick: false,
        position: 'centerCenter',
        backdrop: 0.5,
        html: '<div class="snotifyToast__title">End Assignment</div>' +
            '<div class="snotifyToast__body">' +
            'Are you sure you wish to end the assignment for:<br><br>' +
            '<strong class="mb-2 d-block">' + this.worker.person.first_name + ' ' + this.worker.person.surname + '</strong>' +
            '<strong class="mb-2 d-block">' + assignment.order_job.order_ref + '</strong>' +
            '<strong class="mb-2 d-block">' + assignment.company.company_name + '</strong>' +
            '<strong class="mb-2 d-block">' + assignment.order_job.rel_order_position.job_title + '</strong>' +
            '<div class="snotify-icon snotify-icon--confirm"><i class="fas fa-2x fa-exclamation-triangle"></i></div>' +
            '</div>',
        buttons: [
          {
            text: 'End Assignment', action: (toast) => {
              assignment.assigned = false;
              assignment.end_date = this.$moment.utc().format('YYYY-MM-DD')
              assignment.log_by_type = 'App\\Models\\Users\\User';
              assignment.log_by_id = this.$store.state.auth.me.id;
              axios.post(this.crmApiPath + 'timesheet/record/end_assignment/' + assignment.id).then(() => {
                axios.patch(this.crmApiPath + 'assignments/worker_assignments/' + assignment.id, assignment).then(() => {

                  this.$snotify.remove(toast.id);
                  this.$bus.$emit('assignments::reload', {action: true});
                });
              })
            }
          },
          {
            text: 'Cancel', action: (toast) => {
              this.$snotify.remove(toast.id)
            }
          }
        ]
      });
    },
  }
}
</script>

<style scoped lang="scss">
.placement_container {
  margin-bottom: 15px;

  &:last-of-type {
    margin-bottom: 0;
  }

  .placement {
    background: darken($card_background, 5%);
    padding:    10px;

    .gang_leader_go {
      text-decoration-line:  underline;
      text-decoration-style: dotted;

      &:hover, &:focus, &:active, &:active:focus, &.active:focus,
      &.focus, &:active.focus, &.active.focus {
        cursor:                pointer;
        text-decoration-style: solid;
      }
    }

    .placement_details, .placement_buttons {
      display:        inline-block;
      vertical-align: top;
    }

    .placement_details {
      width:         calc(100% - 127px);
      padding-right: 15px;
    }

    .placement_buttons {
      width:      123px;
      text-align: right;
    }
  }
}
</style>
